import {
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import ApplicationLinkIdField from "../../applications/ApplicationLinkIdField";
import CustomerIdLinkIdField from "../../customers/CustomerIdLinkIdField";
import LoanNumLinkIdField from "../../loans/LoanNumLinkIdField";
import CustomTableSmall from "../../unit/CustomTableSmall";
import formatDate from "../../unit/formatDate";

const DashboardSearchApplication = ({ ...props }) => {
  const searchResult = Array.isArray(props.searchResult)
    ? props.searchResult
    : [];
  return (
    <>
      <TableContainer sx={{ maxHeight: 440 }}>
        <CustomTableSmall
          stickyHeader
          aria-label="sticky table"
          id="table-dashboard-search-applications"
          key={"dashboardSearchApplication"}
        >
          <TableHead>
            <TableRow>
              <TableCell align="center" className="hm-table-header">
                App #
              </TableCell>
              <TableCell align="center" className="hm-table-header">
                Loan #
              </TableCell>
              <TableCell align="center" className="hm-table-header">
                User #
              </TableCell>
              <TableCell className="hm-table-header">Product Name</TableCell>
              <TableCell className="hm-table-header">Applicant</TableCell>
              <TableCell className="hm-table-header">Co-Applicant</TableCell>
              <TableCell className="hm-table-header">Guarantor</TableCell>
              <TableCell className="width-text-column hm-table-header">
                Referral
              </TableCell>
              <TableCell className="hm-table-header">
                Application Status
              </TableCell>
              <TableCell className="date-column hm-table-header">
                Date Submitted
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {searchResult == undefined ||
            searchResult.length == 0 ||
            searchResult == null ? (
              <TableRow>
                <TableCell colSpan={8}>No Data </TableCell>
              </TableRow>
            ) : (
              // Applications: App# [linked to the Individual Application], Loan # [linked to the Individual Loan], Product, Applicant [linked to the Individual Customer], Co-Applicant, Guarantor, Referral, Application Status [linked to the Application List]
              searchResult.map((row: any, index: number) => (
                <TableRow key={index} sx={{ maxHeight: "40px" }}>
                  <TableCell sx={{ width: "110px" }} align="center">
                    {row?.sStatus == "Incomplete" ? (
                      <>{row?.id}</>
                    ) : (
                      <ApplicationLinkIdField
                        id={row?.id}
                        loannum={row?.sLoanNum}
                      />
                    )}
                  </TableCell>
                  <TableCell sx={{ width: "110px" }} align="center">
                    {row?.sStatus == "Funded" ? (
                      <LoanNumLinkIdField
                        id={row?.id}
                        loannum={row?.sLoanNum}
                      />
                    ) : (
                      <>{row?.sLoanNum}</>
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {row?.sStatus == "Incomplete" ? (
                      <>{row?.iUserId}</>
                    ) : (
                      <CustomerIdLinkIdField
                        id={row?.iUserId}
                        name={row?.iUserId}
                      />
                    )}
                  </TableCell>
                  <TableCell className="width-text-column">
                    {row?.sProductName}
                  </TableCell>
                  <TableCell className="width-text-column">
                    {row?.sFirstName} {row?.sLastName}
                  </TableCell>
                  <TableCell className="width-text-column">
                    {row?.coFname} {row?.coLname}
                  </TableCell>
                  <TableCell className="width-text-column">
                    {row?.guarantorFname} {row?.guarantorLname}
                  </TableCell>
                  <TableCell className="width-text-column">
                    {row?.sReferral}
                  </TableCell>
                  <TableCell>{row?.sStatus}</TableCell>
                  <TableCell className="dateText">
                    {formatDate(row?.dtInsert)}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </CustomTableSmall>
      </TableContainer>
    </>
  );
};
export default DashboardSearchApplication;
